const CLUE_API_PARAMS = [
    {
        name: 'token',
        required: '是',
        type: 'string',
        explain: 'token',
        desc:''
    },

    {
        name: 'timestamp',
        required: '是',
        type: 'long',
        explain: '时间戳',
        desc:'unix时间戳(毫秒)'
    },
    {
        name: 'name',
        required: '是',
        type: 'string',
        explain: '姓名',
        desc:''
    },

    {
        name: 'mobile',
        required: '是',
        type: 'string',
        explain: '手机号',
        desc:''
    },

    {
        name: 'nickName',
        required: '否',
        type: 'string',
        explain: '昵称',
        desc:''
    },
    
    {
        name: 'gender',
        required: '否',
        type: 'string',
        explain: '性别',
        desc:'可选值(男|女|未知),为提供时默认为 未知'
    },


    {
        name: 'birthDay',
        required: '否',
        type: 'string',
        explain: '生日',
        desc:'举例: 2021-06-23T09:31:32.951Z'
    },

    {
        name: 'profilePhoto',
        required: '否',
        type: 'string',
        explain: '头像',
        desc:'注意该地址可以公网访问'
    },


    {
        name: 'address',
        required: '否',
        type: 'string',
        explain: '联系地址',
        desc:''
    },

    {
        name: 'description',
        required: '否',
        type: 'string',
        explain: '备注/描述',
        desc:''
    }
]

const RESPONSE_CODE_DESC = [
 {code:"0",explain:"请求成功"},
 {code:"400401",explain:"token 参数缺失"},
 {code:"400402",explain:"timestamp 参数缺失"},
 {code:"400403",explain:"name 参数缺失"},
 {code:"400404",explain:"mobile 参数缺失/异常"},
 {code:"400405",explain:"已经存在该条线索(手机号相同)"},
 {code:"400406",explain:"api链接异常"},
 {code:"400440",explain:"token 校验未通过（检查计算 token 参数是否正确）"},
 {code:"400445",explain:"token 校验未通过（检查计算token方式是否正确）"},
] ;

export {CLUE_API_PARAMS,RESPONSE_CODE_DESC}